/**
 * Traits Directory JS
 * Handles search and read more/less toggle
 */

(function() {
  'use strict';

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const searchInput = document.getElementById('td-search');
    const clearBtn = document.getElementById('td-clear');
    const traitsList = document.getElementById('td-list');
    const emptyState = document.getElementById('td-empty');

    if (!searchInput || !traitsList) return;

    // Get all trait cards
    const cards = Array.from(traitsList.querySelectorAll('.trait-card'));

    // Initialize toggle buttons
    initToggleButtons();

    // Search functionality
    searchInput.addEventListener('input', handleSearch);
    
    if (clearBtn) {
      clearBtn.addEventListener('click', clearSearch);
    }

    function handleSearch() {
      const query = searchInput.value.toLowerCase().trim();
      
      // Show/hide clear button
      if (clearBtn) {
        clearBtn.classList.toggle('active', query.length > 0);
      }

      let visibleCount = 0;

      cards.forEach(card => {
        const name = card.dataset.traitName || '';
        const matches = name.includes(query);

        if (matches) {
          card.style.display = '';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      // Show/hide empty state
      if (emptyState) {
        emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
      }
    }

    function clearSearch() {
      searchInput.value = '';
      handleSearch();
      searchInput.focus();
    }

    function initToggleButtons() {
  document.querySelectorAll('.trait-toggle-btn').forEach(btn => {
    const readMoreText = btn.dataset.readMore;
    const readLessText = btn.dataset.readLess;

    btn.addEventListener('click', function () {
      const card = this.closest('.trait-card');
      const longDesc = card.querySelector('.trait-long-desc');
      const toggleText = this.querySelector('.toggle-text');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      if (!longDesc || !toggleText) return;

      if (isExpanded) {
        longDesc.hidden = true;
        this.setAttribute('aria-expanded', 'false');
        toggleText.textContent = readMoreText;
      } else {
        longDesc.hidden = false;
        this.setAttribute('aria-expanded', 'true');
        toggleText.textContent = readLessText;
      }
    });
  });
}
  }
})();